import Links from './Links';
import { ILinkConfig } from './linksConfig';

export { type ILinkConfig };
export default Links;
